/**
 * شخصيات المشروع الرئيسية (زيد، لانا، روبوت بولو).
 * نفس الشخصيات تُعرَض في الكتب التعليمية المرتبطة بمنصة eSoroban — يُفضّل إبقاء
 * المظهر والأسماء متسقة بين التطبيق والمطبوع.
 *
 * Project mascots (Zayd, Lana, Boulot). These characters also appear in the
 * educational textbooks tied to this platform; keep naming and visuals aligned
 * with the printed materials when updating the app.
 */

/** @typedef {{ id: string, imageFile: string, i18nAltKey: string }} ProjectCharacterMeta */

/** @type {Record<string, ProjectCharacterMeta>} */
export const PROJECT_CHARACTERS = {
  /** صورة ترحيب الصفحة الرئيسية (ذكر) — 250px */
  zaydWelcome: {
    id: 'zaydWelcome',
    imageFile: 'zayd-welcome.png',
    i18nAltKey: 'dashboard.student.characterAltZayd',
  },
  /** صورة ترحيب الصفحة الرئيسية (أنثى) — 250px */
  lanaWelcome: {
    id: 'lanaWelcome',
    imageFile: 'lana-welcome.png',
    i18nAltKey: 'dashboard.student.characterAltLana',
  },
  zayd: {
    id: 'zayd',
    imageFile: 'zayd.png',
    i18nAltKey: 'dashboard.student.characterAltZayd',
  },
  zaydWave: {
    id: 'zaydWave',
    imageFile: 'zayd-wave.png',
    i18nAltKey: 'dashboard.student.characterAltZayd',
  },
  lana: {
    id: 'lana',
    imageFile: 'lana.png',
    i18nAltKey: 'dashboard.student.characterAltLana',
  },
  lanaAlt: {
    id: 'lanaAlt',
    imageFile: 'lana-alt.png',
    i18nAltKey: 'dashboard.student.characterAltLana',
  },
  boulot: {
    id: 'boulot',
    imageFile: 'boulot.png',
    i18nAltKey: 'dashboard.student.characterAltBoulot',
  },
};

/**
 * @param {string} imageFile file name under /public/images/characters/
 * @returns {string}
 */
export function characterImageUrl(imageFile) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}/images/characters/${imageFile}`;
}
